import React from 'react';
import '../../styles/FileManagementModal.css';

const FileManagementModal = ({ 
  show, 
  handleClose, 
  title, 
  files, 
  onRemoveFile, 
  onClearAll, 
  fileType 
}) => {
  if (!show) return null;

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const getFileIcon = (type) => {
    switch (type) {
      case 'photos':
        return 'fas fa-camera';
      case 'videos':
        return 'fas fa-video';
      case 'audio':
        return 'fas fa-microphone';
      case 'files':
        return 'fas fa-file';
      default:
        return 'fas fa-file';
    }
  };

  const getFileTypeColor = (type) => {
    switch (type) {
      case 'photos':
        return 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)';
      case 'videos':
        return 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)';
      case 'audio':
        return 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)';
      case 'files':
        return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
      default:
        return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
    }
  };

  const renderFilePreview = (file) => {
    if (fileType === 'photos') {
      return (
        <img 
          src={file.preview} 
          alt={file.name} 
          className="file-preview-image"
        />
      );
    } else if (fileType === 'videos') {
      return (
        <video 
          src={file.preview} 
          className="file-preview-video"
          muted
        />
      );
    } else if (fileType === 'audio') {
      return (
        <div className="file-preview-audio">
          <i className="fas fa-music"></i>
        </div>
      );
    } else {
      return (
        <div className="file-preview-file">
          <i className="fas fa-file"></i>
        </div>
      );
    }
  };

  return (
    <div className="file-management-overlay" onClick={handleClose}>
      <div className="file-management-modal" onClick={(e) => e.stopPropagation()}>
        <div className="file-management-header">
          <h3 className="file-management-title">{title}</h3>
          <button className="file-management-close" onClick={handleClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="file-management-content">
          {files.length === 0 ? (
            <div className="no-files">
              <div className="no-files-icon">
                <i className={getFileIcon(fileType)}></i>
              </div>
              <p>No hay archivos de este tipo</p>
            </div>
          ) : (
            <>
              <div className="files-list">
                {files.map((file) => (
                  <div key={file.id} className="file-item">
                    <div className="file-preview">
                      {renderFilePreview(file)}
                    </div>
                    <div className="file-info">
                      <div className="file-name">{file.name}</div>
                      <div className="file-size">{formatFileSize(file.size)}</div>
                    </div>
                    <button 
                      className="remove-file-btn"
                      onClick={() => onRemoveFile(file.id)}
                      title="Eliminar archivo"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                ))}
              </div>
              
              <div className="file-management-actions">
                <button 
                  className="clear-all-btn"
                  onClick={onClearAll}
                  disabled={files.length === 0}
                >
                  <i className="fas fa-trash-alt"></i>
                  Limpiar Todos
                </button>
                <div className="files-count">
                  {files.length} archivo{files.length !== 1 ? 's' : ''}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileManagementModal;
